module.exports = __webpack_public_path__ + "media/images/area/feature/okinawa/related/id_3-bf737d038bf2ae483f16d8ccdae9696c.jpg";